import { OrderForm, Restrictions, TrialConfiguration, Integration, AppType } from '@galaxy/marketplace-apps/v1';
// TODO: copy this and remove unneeded fields
export class ResellerItem {
  appId?: string;
  addonId?: string;
  name?: string;
  type?: AppType;
  icon?: string;
  tagline?: string;
  headerImage?: string;
  currency?: string;
  price?: number;
  setupFee?: number;
  billingFrequency?: string;
  lmiCategories?: string[];
  enabled: boolean;
  isCustom: boolean;
  orderForm?: OrderForm;
  quantity = 1;
  allowMultipleActivations: boolean;
  usesCustomizationForm: boolean;
  usesActivationSpecificEntryUrl: boolean;
  entryUrl: string;
  restrictions?: Restrictions;
  activationRequiresApproval?: boolean;
  billingId?: string;
  usesEditions: boolean;
  editionIds: string[];
  suggestedRetailPrice: number; // price is in cents
  editionId?: string;
  trialConfiguration?: TrialConfiguration;
  integration?: Integration;
  suspended?: Date;
  usesCustomPricing?: boolean;

  constructor(data?: any) {
    data = data || {};
    Object.assign(this, data);
  }
}
